import * as React from 'react'
import 'cleave.js/dist/addons/cleave-phone.us'
import Cleave from 'cleave.js/react'
import classnames from 'classnames'

import styles from '../styles.module.scss'
import { useField } from 'formik'

type Props = React.InputHTMLAttributes<HTMLInputElement>

export const PhoneNumberInput: React.FC<Props> = (props) => {
  const { className, ...rest } = props
  const [, meta] = useField(rest.name)
  const inputClassName = classnames(styles.input, className, {
    [styles.inputError]: meta.error && meta.touched,
  })

  return (
    <Cleave
      {...rest}
      autoComplete="off"
      className={inputClassName}
      options={{ phone: true, phoneRegionCode: 'us' }}
      type="tel"
    />
  )
}
